import React, { Component } from "react";
import { Image } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import {
  resetSearchInputData,
  toggleSidebar
} from "../../actions/common.action";
import PermissionHOC from "../PermissionHOC";
import { get } from "lodash";
import {
  SideBarMenuTemplate,
  GroupDropDownOptions
} from "../reusableComponent";
import { isValidArray, getLocalstorage } from "../../helper";
import GroupManagement from "../../assets/group-management.svg";
import Arrow from "../../assets/arrow-pointing.svg";
import DraftArrow from "../../assets/draft-arrow.svg";
import { getDraftUserCount } from "../../actions/userManagement.action";

class GroupManagementSidebar extends Component {
  state = {
    dropDown: GroupDropDownOptions,
    selectedTab: "group"
  };

  onSelectedTab = e => {
    const {
      dataset: { title }
    } = e.target;
    const { handleGroupManagementActions } = this.props;
    this.setState({ selectedTab: title });
    handleGroupManagementActions(e.target.id);
  };

  // We can uncomment when draft user creation functionality will add

  // componentDidMount() {
  //   const { getUsersCountDispatch } = this.props;
  //   getUsersCountDispatch(undefined).then(iigUserCount => {
  //     this.setState({
  //       isIIGUserCount: iigUserCount
  //     });
  //   });
  // }

  render() {
    const {
      state: { dropDown, isIIGUserCount },
      props: { permission, selectedTab, toggleSideBar },
      onSelectedTab
    } = this;
    const userInfo = getLocalstorage("user");
    const isUserPMG = get(userInfo, "groupCategory") === "PMG";

    const active = (window.innerWidth > 991 && !toggleSideBar) || toggleSideBar;
    return (
      <React.Fragment>
        <div
          className={`${
            active
              ? `mis-sidebar-wrapper sidebar-transition`
              : `show-less mis-sidebar-wrapper`
          }`}
        >
          <SideBarMenuTemplate
            containerClasses="mis-project-menu"
            options={dropDown}
            headerTemplate={({ index, title, dropDown, expandView }) => (
              <div className="heading pb-3" data-index={index}>
                <span className="group-management">
                  <Image src={GroupManagement} className="image-class" />
                </span>
                {title}
              </div>
            )}
            subMenuTemplate={({ readBy = "", title, reportBy, downloadBy }) => {
              return get(permission, readBy) !== undefined ||
                (isUserPMG &&
                  (title === "Draft User" || title === "Best Practices")) ? (
                <div
                  data-title={title}
                  data-reportby={reportBy}
                  className={`submenu ${
                    selectedTab === title ? "submenu-active" : ""
                  }`}
                  id={title}
                  onClick={onSelectedTab}
                >
                  <span
                    className={` ${
                      title === "Draft User"
                        ? "iig-draft pl-3"
                        : "group-managements"
                    }`}
                    id={title}
                  >
                    <Image
                      src={title === "Draft User" ? DraftArrow : Arrow}
                      id={title}
                    />
                  </span>
                  {title}{" "}
                  {isIIGUserCount !== undefined &&
                    isIIGUserCount.data !== undefined &&
                    title === "Draft User" &&
                    " (" + isIIGUserCount.data + ")"}
                </div>
              ) : (
                <React.Fragment />
              );
            }}
          />
        </div>
      </React.Fragment>
    );
  }
}

GroupManagementSidebar.propTypes = {
  toggleSideBar: PropTypes.bool
};

GroupManagementSidebar.defaultProps = {
  toggleSideBar: false
};

function mapStateToProps(state) {
  return {
    toggleSideBar: state.commonReducer.toggleSideBar,
    searchInput: state.commonReducer.searchInput,
    usersListing: state.userManagementReducer.usersListing
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleSideBarDispatch: toggleSidebar,
      resetSearchInputData: resetSearchInputData
      // getUsersCountDispatch: getDraftUserCount
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PermissionHOC(GroupManagementSidebar));
